import { useTranslation } from 'react-i18next'

import { Button, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CustomerNotesCardError = ({ onRetry }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleM">{t('No se pudo analizar las notas')}</Text>
      <Text type="bodyMRegular">{t('Inténtalo de nuevo.')}</Text>
      {onRetry && (
        <Button variant="outlined" onClick={onRetry}>
          {t('Reintentar')}
        </Button>
      )}
    </Styles.Container>
  )
}

export default CustomerNotesCardError
